import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function ZscalerZpaConnectForm({ onSubmit, guideMode }) {
  const [showSecret, setShowSecret] = useState(false);
  const handleClickShowSecret = () => setShowSecret(!showSecret);
  const handleMouseDownSecret = () => setShowSecret(!showSecret);
  const formInitialValues = {
    clientId: "",
    secret: "",
    zpa_customer_id: "",
  };
  const formCheckoutSchema = yup.object().shape({
    clientId: yup.string().required("required"),
    secret: yup.string().required("required"),
  });
  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                name="clientId"
                label="Client ID"
                value={values.clientId}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.clientId && !!errors.clientId}
                helperText={touched.clientId && errors.clientId}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                type={showSecret ? "text" : "password"}
                name="secret"
                autoComplete="off"
                label="Client Secret"
                value={values.secret}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.secret && !!errors.secret}
                helperText={touched.secret && errors.secret}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle secret visibility"
                        onClick={handleClickShowSecret}
                        onMouseDown={handleMouseDownSecret}
                      >
                        {showSecret ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="zpa_customer_id"
                label="Tenant ID"
                value={values.zpa_customer_id}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.clientId && !!errors.clientId}
                helperText={touched.clientId && errors.clientId}
                disabled={guideMode}
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
